import { invert, reduce } from 'lodash'

export const mapData = (mapping: object, data: object, toServer: boolean, addEmpty = false) => {
  // tslint:disable-next-line:variable-name
  const _mapping = (toServer ? mapping : invert(mapping))
  return reduce(_mapping, (result, clientKey, serverKey) => {
    if ((data[clientKey] || data[clientKey] === false) || addEmpty) {
      result[serverKey] = data[clientKey]
    }
    return result
  }, {})
}

export const USER_API_MAPPING = {
  id: 'id',
  first_name: 'firstName',
  last_name: 'lastName',
  email: 'email',
  cell: 'phone',
  cell_certified: 'phoneVerified',
  company: 'company',
  lang: 'locale',
  enterprise_id: 'entrepriseId',
  image_report: 'companyLogoId',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  picture: 'avatarID',
  access_token: 'token',
  admin: 'admin'
}

export const REPORT_ROW_API_MAPPING = {
  id: 'id',
  proov_code: 'proovCode',
  state: 'state',
  owner: 'ownerId',
  dropoff: 'dropoff',
  full_dropoff: 'fullDropoff',
  auto_restart: 'autoRestart',
  updatedAt: 'updatedAt',
  finished_at: 'finishedAt',
  createdAt: 'createdAt',
  dropoff_finished_at: 'dropoffFinishedAt'
}

export const REPORT_API_MAPPING = {
  ...REPORT_ROW_API_MAPPING,
  createdAt: 'createdAt'
}

export const MISSION_ROW_API_MAPPING = {
  id: 'id',
  email: 'email',
  title: 'title',
  description: 'description',
  start_date: 'startDate',
  due_date: 'dueDate',
  address: 'address',
  state: 'state',
  report_state: 'reportState',
}

export const MISSION_API_MAPPING = {
  email: 'email',
  title: 'title',
  description: 'description',
  report_state: 'reportState',
  proov_code: 'proovCode',
  start_date: 'startDate',
  due_date: 'dueDate',
  phone_number: 'phoneNumber',
  body_sms: 'bodySms',
  send_email: 'sendEmail'
}

export const WEBHOOK_API_MAPPING = {
  id: 'id',
  first_finished: 'firstFinished',
  second_finished: 'secondFinished',
  update: 'update',
  init: 'init',
  secret_key: 'secretKey',
  url: 'url',
  createdAt: 'createdAt'
}

export interface UserType {
  id: number
  firstName: string
  lastName: string
  email: string
  phone: string
  phoneVerified: boolean
  entrepriseId: number
  companyLogoId: number
  company: string
  locale: string
  updatedAt: string
  createdAt: string
  avatarID: number
  token: string
  admin: boolean
}
